import type {ComponentProps} from 'react';
import {cn} from '../lib/cn';

export type FormBoxSubHeaderProps = ComponentProps<'h4'>;

export function SubHeader({children, className, ...props}: FormBoxSubHeaderProps) {
  return (
    <h4
      className={cn(
        'm-0 flex items-center gap-2 self-stretch border-b border-[var(--form-box-subtitle-border)] px-0 py-2 text-base font-semibold leading-normal text-[var(--form-box-subtitle-color)]',
        className,
      )}
      {...props}
    >
      {children}
    </h4>
  );
}
